module.exports = __webpack_public_path__ + "img/location-icon.3154a52c.svg";